import { CustomRouteConfig } from "@/models/plugins/CustomRouterTypes";
import PERMISSIONS from "@/static/permissions";

export enum BOOKING_ROUTE_NAME {
  Bookings = "Bookings",
  TouristModule = "Tourist Module",
  NewBooking = "New booking",
  EditBooking = "Edit booking",
  CloneBooking = "Clone booking",
}

const BookingsRoutes: Array<CustomRouteConfig> = [
  {
    name: BOOKING_ROUTE_NAME.Bookings,
    path: "bookings",
    component: () => import(/* webpackChunkName: "bookings" */ "@/views/bookings/BookingsView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookingsRead] },
  },
  {
    name: BOOKING_ROUTE_NAME.TouristModule,
    path: "tourist-module",
    component: () => import(/* webpackChunkName: "bookings" */ "@/views/bookings/TouristModuleView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookingsRead] },
  },
  {
    name: BOOKING_ROUTE_NAME.NewBooking,
    path: "bookings/new",
    component: () => import(/* webpackChunkName: "bookings" */ "@/views/bookings/BookingsNewView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookingsCreate] },
  },
  {
    name: BOOKING_ROUTE_NAME.EditBooking,
    path: "bookings/edit/:id",
    component: () => import(/* webpackChunkName: "bookings" */ "@/views/bookings/BookingsEditView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookingsUpdate] },
  },
  {
    name: BOOKING_ROUTE_NAME.CloneBooking,
    path: "bookings/clone",
    component: () => import(/* webpackChunkName: "bookings" */ "@/views/bookings/BookingsCloneView.vue"),
    meta: { hasOneOfPermissions: [PERMISSIONS.BookingsCreate] },
  },
];

export { BookingsRoutes };
export default BookingsRoutes;
